// extracted by mini-css-extract-plugin
export default {"sentry-error-embed-wrapper":"sentry-error-embed-wrapper","sentry-error-embed":"sentry-error-embed","powered-by":"powered-by"};